import { BottomSheet as UIBottomSheet } from "@webmotors/eleanor-ui";
import { BottomSheetProps as UIBottomSheetProps } from "@webmotors/eleanor-ui/webmotors/bottom-sheet";

export function BottomSheet(props: Readonly<BottomSheetProps>) {
  return <UIBottomSheet {...props} data-testid="bottom-sheet" />;
}

export type BottomSheetProps = UIBottomSheetProps;
